import React, { useEffect, useRef, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import { useAuth } from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const AddGallery = () => {
    const { logout, user } = useAuth();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [imgFile, setImgFile] = useState(null)
    const [active, setActive] = useState(true)
    const [loading, setLoading] = useState(false)
    const [previewImgUrl, setPreviewImgUrl] = useState(null);
    const placeholderImg = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQD4qmuiXoOrmp-skck7b7JjHA8Ry4TZyPHkw&s"; // Or import your own placeholder


    const imgFileRef = useRef()

    const handleSubmit = (e) => {
        e.preventDefault();

        let isValid = true;

        if (!imgFile || imgFile.length === 0) {
            toast.error("Please upload a gallery image");
            isValid = false;
        }

        if (!isValid) return;

        const formData = new FormData();
        formData.append('imgFile', imgFile[0]);
        formData.append('show', active);
        setLoading(true)

        axios
            .post(`${baseUrl}/gallery/add`, formData)
            .then((res) => {
                toast.success(res.data.message);
                setActive(true);
                setImgFile(null);
                imgFileRef.current.value = '';
                setPreviewImgUrl(null)
                setLoading(false)
            })
            .catch((err) => {
                toast.error(err?.response?.data?.message || 'Something went wrong');
                console.error(err);
                setLoading(false)
            });
    };


    const handleImgFile = (e) => {
        const file = e.target.files[0];
        const validFileTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        const maxSizeInBytes = 2 * 1024 * 1024;

        if (file && validFileTypes.includes(file.type) && file.size <= maxSizeInBytes) {
            setImgFile(e.target.files);
            setPreviewImgUrl(URL.createObjectURL(file)); // <-- This line enables preview
        } else {
            toast.error('Invalid file. Only Image files (jpeg, jpg, png) under 2MB are allowed.');
            setImgFile(null);
            setPreviewImgUrl(null); // Clear the preview if the file is invalid
            imgFileRef.current.value = "";
        }
    };
    useEffect(() => {
        return () => {
            if (previewImgUrl) {
                URL.revokeObjectURL(previewImgUrl);
            }
        };
    }, [previewImgUrl]);


    return (
        <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
            <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
                <SideBar />
            </aside>

            <main className={styles.mainContent}>
                <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
                <nav aria-label="breadcrumb" >
                    <ol className="breadcrumb">
                        <div className="d-flex flex-grow-1">
                            <li className="breadcrumb-item">
                                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to='/admin/gallery' className="text-decoration-none">Gallery</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                Add Gallery
                            </li>
                        </div>
                        <li className="nav-item dropdown">
                            <span
                                className="nav-link dropdown-toggle"
                                data-bs-toggle="dropdown"
                                href=""
                                role="button"
                                aria-expanded="false"
                            >
                                Welcome, {user.name}
                                <i className="ml-2 fa fa-angle-down"></i>
                            </span>
                            <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                                <li>
                                    <span className="dropdown-item" onClick={logout}>
                                        Logout
                                    </span>
                                </li>
                            </ul>
                        </li>
                    </ol>
                </nav>
                <div
                    className={`container ${styles.container}`}>
                    <div className="bg-white p-4">
                        <h4>Add Gallery</h4>

                        <div className="row mt-3">
                            <div className="col-lg-6">
                                <label htmlFor="imgFile" className="form-label">
                                    Student Image
                                </label>
                                <input
                                    id="imgFile"
                                    ref={imgFileRef}
                                    onChange={handleImgFile}
                                    type="file"
                                    className="form-control"
                                />
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-2">
                                    <label className="form-label d-block">Image Preview:</label>
                                    <img
                                        src={
                                            previewImgUrl
                                                ? previewImgUrl
                                                : placeholderImg
                                        }
                                        alt="ImagePreview"
                                        style={{ width: "100%", height: "auto" }}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="row mt-3">
                            <div className="col-lg-6">
                                <label htmlFor="status" className="form-label">
                                    Status :                   {
                                        active ?
                                            <label htmlFor="active" className="form-label">
                                                Active
                                            </label> :
                                            <label htmlFor="inactive" className="form-label">
                                                Inactive
                                            </label>
                                    }
                                    <input checked={active} onChange={() => setActive(!active)} className="ml-2" type="checkbox" />
                                </label>
                            </div>
                        </div>

                        <button disabled={loading} onClick={handleSubmit} className="btn btn-primary mt-4">
                            {loading ? 'Loading...' : 'Submit'}
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default AddGallery;